import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

export default function Themquanlyvipham() {
  const [loaivipham, setLoaivipham] = React.useState([]);
  const [loaiviphamvalue, setLoaiviphamvalue] = React.useState(0);
  const [coquanxuly, setCoquanxuly] = React.useState([]);
  const [coquanxulyvalue, setCoquanxulyvalue] = React.useState(0);
  const [tinhtrang, setTinhtrang] = React.useState([]);
  const [tinhtrangvalue, setTinhtrangvalue] = React.useState(0);
  const [bienkiemsoat, setBienkiemsoat] = React.useState("");
  const [ngayvipham, setNgayvipham] = React.useState(dayjs());
  const [motavipham, setMotavipham] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getloaivipham = () => {
    var url =
      Config.backend + "/api/Vipham/getdmloaivipham?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaivipham(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getcoquanxuly = () => {
    var url =
      Config.backend +
      "/api/donvi/getdonvitheoloaidonvi?dmloaidonvi_id=11&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setCoquanxuly(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const gettinhtrang = () => {
    var url = Config.backend + "/api/ViPham/getdmttvipham?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTinhtrang(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const insertbaocao = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var ngayvp =
        ngayvipham.$y +
        "-" +
        String(ngayvipham.$M + 1).padStart(2, "0") +
        "-" +
        ngayvipham.$D;
      var url = Config.backend + "/api/ViPham/themxulyvp";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          bienkiemsoat: bienkiemsoat,
          ngayvipham: ngayvp,
          loaivipham_id: loaiviphamvalue,
          motavipham: motavipham,
          tinhtrangxulyvipham_id: tinhtrangvalue,
          coquanxulyvipham_id: coquanxulyvalue,
          nhomvipham_id: 2,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateThem = () => {
    // Kiem tra cac truong bat buoc nhap
    if (!loaiviphamvalue || loaiviphamvalue === 0) {
      return Error.ER0018;
    }
    if (!coquanxulyvalue || coquanxulyvalue === 0) {
      return Error.ER0019;
    }
    if (!tinhtrangvalue || tinhtrangvalue == 0) {
      return Error.ER0020;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getloaivipham();
    getcoquanxuly();
    gettinhtrang();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày vi phạm"
                  value={ngayvipham}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgayvipham(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Biển kiểm soát"
                variant="outlined"
                size="small"
                value={bienkiemsoat}
                onChange={(event) => {
                  setBienkiemsoat(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={loaivipham}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setLoaiviphamvalue(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setLoaiviphamvalue(null);
                  } else {
                    setLoaiviphamvalue(
                      loaivipham.find(({ ten }) => ten === newInputValue).id
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Loại vi phạm"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Mô tả vi phạm"
                variant="outlined"
                size="small"
                value={motavipham}
                onChange={(event) => {
                  setMotavipham(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={coquanxuly}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setCoquanxulyvalue(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setCoquanxulyvalue(null);
                  } else {
                    setCoquanxulyvalue(
                      coquanxuly.find(({ ten }) => ten === newInputValue).id
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cơ quan xử lý"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={tinhtrang}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setTinhtrangvalue(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setTinhtrangvalue(null);
                  } else {
                    setTinhtrangvalue(
                      tinhtrang.find(({ ten }) => ten === newInputValue).id
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Trạng thái xử lý"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={insertbaocao}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình thêm"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
